import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import authReducer from "./authSlice";
import heldOrdersReducer from "./heldOrdersSlice";
import { api } from "./api";
import { centralApi } from "./centralApi";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    heldOrders: heldOrdersReducer,
    [api.reducerPath]: api.reducer,
    [centralApi.reducerPath]: centralApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(api.middleware, centralApi.middleware),
});

setupListeners(store.dispatch);
